import { connect } from 'react-redux';

import { loadReportModalSelector, skipItem, toggleLoadReportModal } from '../../../redux/modals';
import LoadReportModal from './LoadReportModal';

const mapStateToProps = loadReportModalSelector;

const mapDispatchToProps = {
  onHide: toggleLoadReportModal,
  onSkipItem: skipItem
};

export default connect(mapStateToProps, mapDispatchToProps)(LoadReportModal);
